(ns dashboard.views.answer-bank.config
  (:require
   [reitit.frontend.easy :as rfe]))

(def view-id :route.view/answer-bank)

(defn breadcrumbs []
  [{:href (rfe/href :route.view/home) :label "Dashboard"}
   {:href (rfe/href view-id) :label "Answer Bank" :active? true}])
